import "./NotificationsPopup.css";
import React, { Fragment, useMemo, useState } from "react";

import AddBusinessIcon from "@mui/icons-material/AddBusiness";
import AssuredWorkloadIcon from "@mui/icons-material/AssuredWorkload";
import DensitySmallIcon from "@mui/icons-material/DensitySmall";
import UpdateNotificationStatus from "../../../controllers/users/UpdateNotificationStatus";
import {
  // intervalToDuration,
  isThisMonth,
  isThisWeek,
  isThisYear,
  isToday,
  isYesterday,
} from "date-fns";
import { Link } from "@mui/material";
// import { PresentToAll } from "@mui/icons-material";

const NotificationsPopup = ({ notification }) => {
  const [Duration, setDuration] = useState("");
  const size = Object.keys(notification).length;

  useMemo(() => {
    setDuration(
      isToday(new Date(notification?.createdAt?.toDate()))
        ? "Today " +
            notification?.createdAt?.toDate()?.toLocaleString("en-US", {
              hour: "numeric",
              minute: "numeric",
            })
        : isYesterday(new Date(notification?.createdAt?.toDate()))
        ? "Yesterday " +
          notification?.createdAt?.toDate()?.toLocaleString("en-US", {
            hour: "numeric",
            minute: "numeric",
          })
        : isThisWeek(new Date(notification?.createdAt?.toDate()))
        ? "This Week, " +
          notification?.createdAt?.toDate()?.toLocaleString("en-US", {
            weekday: "long",
            year: "numeric",
            month: "short",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
          })
        : isThisMonth(new Date(notification?.createdAt?.toDate()))
        ? "This Month, " +
          notification?.createdAt?.toDate()?.toLocaleString("en-US", {
            weekday: "long",
            year: "numeric",
            month: "short",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
          })
        : isThisYear(new Date(notification?.createdAt?.toDate()))
        ? "This Year, " +
          notification?.createdAt?.toDate()?.toLocaleString("en-US", {
            weekday: "long",
            year: "numeric",
            month: "short",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
          })
        : notification?.createdAt?.toDate()?.toLocaleString("en-US", {
            weekday: "long",
            year: "numeric",
            month: "short",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
          })
    );
  }, [notification?.createdAt]);
  const onClickHandler = async () => {
    const notificationId = notification?.id;
    await UpdateNotificationStatus(notificationId);
  };

  return (
    <div
      onClick={onClickHandler}
      className={`dropdown-notifications-list-item ${
        notification?.is_seen === false ? "unread-notification" : ""
      }`}
    >
      <div className="notification-icon">
        {notification?.notification_type === "Deal is Won" ? (
          <AssuredWorkloadIcon />
        ) : notification?.notification_type === "Shared" ? (
          <AddBusinessIcon />
        ) : (
          <DensitySmallIcon />
        )}
      </div>

      <div className="notification-content">
        <div className="notification-title">{notification?.title}</div>
        <small className="notification-time">{` ${Duration}`}</small>
      </div>
    </div>
  );
};

export default NotificationsPopup;
